import React, { useEffect, useState } from 'react'
import { socket } from '../../../App';
import {Button, FormCheck} from 'react-bootstrap';
import notificationService from '../../../api/notification.api';
import { convertUTCToDatestring } from '../../../helpers/convertUTCToDatestring';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../helpers/routeConsts';
import {useStores} from "../../../stores";


type Props = {}

export interface INotificationMessage {
    id: number
    author: string
    action: string
    link: string
    date: string
    type: string
    watched: boolean
}

function debounce<T extends (...args: any[]) => void>(func: T, delay: number): T {
    let timer: NodeJS.Timeout;

    return function (...args: Parameters<T>) {
        clearTimeout(timer);
        timer = setTimeout(() => func(...args), delay);
    } as T;
}


const Notifications = (props: Props) => {
    const [messages, setMessages] = useState<INotificationMessage[]>([]);
    const [newMessage, setNewMessage] = useState<boolean>(false)
    const [show, setShow] = useState<boolean>(false)
    const [isAll, setIsAll] = useState(false);
    const { authStore } = useStores();
    const vacancyCompanyId = authStore.user?.vacancyCompany || null

    const update = (value?: boolean) => {
        notificationService.getNotifications(vacancyCompanyId, value)
          .then(response => {
              setMessages(response.data.filter((m: INotificationMessage) => !m.watched));
          })
          .catch(e => console.log(e));
    };

    const handleToggle = () => {
        setIsAll(prev => {
            const newValue = !prev;
            update(newValue);
            return newValue;
        });
    };

    const skipNotification = (id: number) => {
        notificationService.skipNotification(id).then(() => update());
    }

    const skipAllNotifications = () => {
        messages.forEach(message => skipNotification(message.id));
    }

    const debouncedUpdate = debounce(() => {
        update();
    }, 1000);

    useEffect(() => {
        update();

        const messageHandler = (msg: string) => {
            setNewMessage(true);
            debouncedUpdate();
        };

        socket.on('chat message', messageHandler);


        return () => {
            socket.off('chat message', messageHandler);
        };
    }, []);

    return (
        <div className='notifications'>
            <Button onClick={() => {
                setShow((prev) => (!prev))
                setNewMessage(false)
            }} id="notification-toggle">
                {
                    newMessage ?
                        <i className="fa-solid fa-bell"></i>
                        :
                        <i className="fa-regular fa-bell"></i>
                }
            </Button>

            {
                show && <div className="messages shadow-lg" id="notification-messages">
                    <li className={'px-3 py-2 flex gap-4 justify-between items-center'}><Link to={ROUTES.NOTIFICATIONS}>
                        <div className="message-item">
                            Все уведомления
                        </div>
                    </Link>
                        {
                            !authStore.user?.vacancyCompany && (
                            <FormCheck
                              type="checkbox"
                              id="show-all-notifications"
                              label="Только заказчики"
                              checked={isAll}
                              onChange={handleToggle}
                            />
                          )
                        }

                    </li>
                    <ul>
                        <div style={{maxHeight: 400, overflowY: 'auto'}}>
                            {
                                messages.map((message, index) => {
                                    return (
                                      <li key={index} className='position-relative'>
                                          <Link to={message.link} onClick={() => setShow(false)}>
                                              <div className="message-item position-relative pe-3">
                                                  <small>
                                                      {convertUTCToDatestring(message.date)} - <b>{message.author}</b>
                                                  </small>
                                                  <p className='mb-0'>
                                                      {message.action}
                                                  </p>
                                              </div>
                                          </Link>
                                          <Button size={'sm'} title="скрыть"
                                                  style={{position: 'absolute', top: 10, right: 10}}
                                                  onClick={() => skipNotification(message.id)}
                                          ><i className="fa-solid fa-xmark"></i></Button>
                                      </li>
                                    )
                                })
                            }
                        </div>
                        {
                          messages.length > 1 && <li>
                              <div className="message-item " style={{cursor: 'pointer'}} onClick={skipAllNotifications}>
                                  <i className="fa-solid fa-xmark"></i> Очистить все уведомления
                              </div>
                          </li>
                        }
                    </ul>
                </div>
            }
        </div>
    );
}

export default Notifications